<p-dialog [header]="'emojiList.addEmoji' | transloco" [modal]="true" [(visible)]="showDialog" [style]="{'width': '400px'}"
  (onHide)="onDialogClosed($event)">
  <emoji-mart (emojiClick)="onEmojiClick($event)" [style.width.px]="400"></emoji-mart>
</p-dialog>